import React from 'react';
import {Modal} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import i18n from 'i18n-js';
import ConfirmationDialog from '../../commons/modal/ConfirmationDialog';
import {
  closeAction,
  submitAddNote,
  restartOrder,
  removeCurrentItem,
  assignToteSet
} from '../../actions/productFirstActions';
import {selectToteIdentifier} from '../../selectors/productFirstSelectors';

const PutWallDialogs = () => {
  const dispatch = useDispatch();
  const toteIdentifier = useSelector(selectToteIdentifier);
  const {isVisible, type} = useSelector(state => state.productFirst.prompt);

  if (!isVisible) return null;

  let dialog = null;

  if (type === 'AddNote') {
    dialog = (
      <ConfirmationDialog
        showButtons={false}
        showInput
        title={i18n.t('productFirst.addNote')}
        inputPlaceholder={i18n.t('productFirst.addNotePlaceholder')}
        onClose={() => dispatch(closeAction())}
        onSubmit={note => dispatch(submitAddNote(note))}
      />
    );
  } else if (type === 'RestartOrder') {
    dialog = (
      <ConfirmationDialog
        title={i18n.t('productFirst.restartOrder')}
        message={i18n.t('productFirst.restartConfirm', {toteIdentifier})}
        onConfirm={() => dispatch(restartOrder())}
        onCancel={() => dispatch(closeAction())}
        onClose={() => dispatch(closeAction())}
      />
    );
  } else if (type === 'RemoveItem') {
    dialog = (
      <ConfirmationDialog
        title={i18n.t('productFirst.removeItem')}
        message={i18n.t('productFirst.removeConfirm')}
        onConfirm={() => dispatch(removeCurrentItem())}
        onCancel={() => dispatch(closeAction())}
        onClose={() => dispatch(closeAction())}
      />
    );
  } else if (type === 'SwitchToteSet') {
    dialog = (
      <ConfirmationDialog
        showButtons={false}
        showInput
        title={i18n.t('productFirst.switchToteSet', {toteIdentifier})}
        inputPlaceholder={i18n.t('productFirst.claimPlaceholder', {toteIdentifier})}
        onClose={() => dispatch(closeAction())}
        onSubmit={input => {
          dispatch(closeAction());
          dispatch(assignToteSet(input));
        }}
      />
    );
  }

  if (!dialog) return null;

  return (
    <Modal transparent visible animationType="fade" onRequestClose={() => dispatch(closeAction())}>
      {dialog}
    </Modal>
  );
};

export default PutWallDialogs;
